// Theme JavaScript
(function () {
  "use strict";

  // Prevent automatic scrolling on page load
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  // DOM elements
  const header = document.querySelector(".header");
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const cartCount = document.querySelector(".cart-count");

  // Calculate and set body padding based on header height
  function adjustBodyPadding() {
    if (header) {
      // Get the complete header height including the scrolling text bar
      const headerHeight = header.offsetHeight;
      document.body.style.paddingTop = headerHeight + "px";

      // Also update the mobile menu position if it exists
      const mobileMenu = document.querySelector("#mobile-menu");
      if (mobileMenu) {
        mobileMenu.style.top = headerHeight + "px";
        mobileMenu.style.height = `calc(100% - ${headerHeight}px)`;
      }
    }
  }

  // Call on page load
  adjustBodyPadding();

  // Recalculate on window resize
  window.addEventListener("resize", adjustBodyPadding);

  // Recalculate when scrolling text is toggled (via theme editor)
  document.addEventListener("shopify:section:load", function (event) {
    if (event.detail.sectionId.includes("header")) {
      adjustBodyPadding();
    }
  });

  // Mobile menu functionality
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener("click", function () {
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  // Sticky header - header will now remain visible at all times
  // The CSS position: sticky will handle the stickiness
  /* Remove the scroll-based hiding behavior
  let lastScrollTop = 0;
  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 100) {
      header.classList.add("is-hidden");
    } else {
      header.classList.remove("is-hidden");
    }

    lastScrollTop = scrollTop;
  });
  */

  // Cart functionality
  function updateCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.classList.toggle("hidden", cart.item_count === 0);
        }
      })
      .catch((error) => console.error("Error:", error));
  }

  // Initialize cart count
  updateCart();

  // Listen for cart updates
  document.addEventListener("cart:updated", updateCart);

  // Product Card functionality
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector(".product-card__form");
      this.quantityInput = this.querySelector(".quantity-input");
      this.decreaseButton = this.querySelector('[data-action="decrease"]');
      this.increaseButton = this.querySelector('[data-action="increase"]');
      this.addToCartButton = this.querySelector(".add-to-cart-button");

      this.init();
    }

    init() {
      if (this.quantityInput && this.decreaseButton && this.increaseButton) {
        this.decreaseButton.addEventListener("click", () =>
          this.updateQuantity("decrease")
        );
        this.increaseButton.addEventListener("click", () =>
          this.updateQuantity("increase")
        );
        this.quantityInput.addEventListener("change", () =>
          this.validateQuantity()
        );
      }

      if (this.form) {
        this.form.addEventListener("submit", (event) =>
          this.handleAddToCart(event)
        );
      }
    }

    updateQuantity(action) {
      const currentValue = parseInt(this.quantityInput.value);

      if (action === "decrease" && currentValue > 1) {
        this.quantityInput.value = currentValue - 1;
      } else if (action === "increase") {
        this.quantityInput.value = currentValue + 1;
      }

      this.validateQuantity();
    }

    validateQuantity() {
      const value = parseInt(this.quantityInput.value);
      if (isNaN(value) || value < 1) {
        this.quantityInput.value = 1;
      }
    }

    handleAddToCart(event) {
      event.preventDefault();

      if (!this.addToCartButton.disabled) {
        const formData = new FormData(this.form);

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            // Trigger cart update event
            document.dispatchEvent(new CustomEvent("cart:updated"));

            // Show success message
            const originalText = this.addToCartButton.textContent;
            this.addToCartButton.textContent = "Added to cart";
            this.addToCartButton.disabled = true;

            // Reset button after 2 seconds
            setTimeout(() => {
              this.addToCartButton.textContent = originalText;
              this.addToCartButton.disabled = false;
            }, 2000);
          })
          .catch((error) => {
            console.error("Error:", error);
            this.addToCartButton.textContent = "Error adding to cart";
            setTimeout(() => {
              this.addToCartButton.textContent = "Add to cart";
            }, 2000);
          });
      }
    }
  }

  // Register the ProductCard custom element
  if (!customElements.get("product-card")) {
    customElements.define("product-card", ProductCard);
  }

  // Product form submission
  const productForms = document.querySelectorAll('form[action="/cart/add"]');
  productForms.forEach((form) => {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((item) => {
          updateCart();
          // Trigger mini cart open or show success message
        })
        .catch((error) => console.error("Error:", error));
    });
  });

  // Initialize any product carousels
  const productCarousels = document.querySelectorAll(".product-carousel");
  if (productCarousels.length > 0) {
    productCarousels.forEach((carousel) => {
      // Add your carousel initialization here
      // Example: new ProductCarousel(carousel);
    });
  }

  // Handle quick view buttons
  const quickViewButtons = document.querySelectorAll(".quick-view-button");
  quickViewButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const productUrl = this.getAttribute("data-product-url");

      fetch(productUrl + "?view=quick-view")
        .then((response) => response.text())
        .then((html) => {
          // Add your quick view modal implementation here
        })
        .catch((error) => console.error("Error:", error));
    });
  });
})();
